import { makeVar } from '@apollo/client';
import { EcpMapUserLocation } from '../../utils/ecp-locator';
import { IEcpStore, TEcpLocatorResponse } from '../../rest/ecp-locator';
import { TFiltersData } from './models/filter-params.models';
import { DEFAULT_CENTER, DEFAULT_FILTERS } from '../../constants/ecp-locator';
import { SortingTypes } from '../../components/business/app/ecp-sort/ecp-sort.models';

export const setStoreDetail = makeVar<IEcpStore | null>(null);
export const ecpStoresCached = makeVar<TEcpLocatorResponse>([]);
export const setMarkerCode = makeVar<string>('');
export const sortingType = makeVar<SortingTypes>(SortingTypes.distance);
export const setStoreCode = makeVar<string>('');
export const setUserLocation = makeVar<EcpMapUserLocation>(DEFAULT_CENTER);
export const setAutocompletedSearch = makeVar<boolean>(false);
export const setAutocompletedValue = makeVar<string>('');
export const setAutoValueSelected = makeVar<boolean>(false);
export const setEcpFormSubmitted = makeVar<boolean>(false);
export const filterParams = makeVar<TFiltersData>({
  ...DEFAULT_FILTERS,
  isFirstTimeLoading: true,
});
export const setError = makeVar<string>('');
export const setStopSearch = makeVar<boolean>(false);
export const setExternalSource = makeVar<string>('');
export const pinnedStoreCode = makeVar<string>('');

export type SearchBounds = [[number, number], [number, number]] | null;
export const setSearchBounds = makeVar<SearchBounds>(null);
